import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import CustomLink from '@gc-npm/components.custom-link';
import TextInfo, {
  TEXT_COLOR,
  TEXT_SIZE,
  TEXT_KIND,
} from '@gc-npm/components.text';
import Glyph from '@gc-npm/components.icon-glyph';
import { ICON_ID } from '@gc-npm/utils.enums.icon-id';
import sendGaEvent from '@gc-npm/utils.metrics.send-ga-event';
import { actions as modalActions } from '@gc-npm/reducers.modals-reducer';
import { downloadDocuments, getModuleNamesTagginInfo } from '@/utils/index';

import Form from '@/components/FormSkeleton';
import {
  actions as uiActions,
} from '@/reducers/ui';
import getColor from '@gc-npm/utils.enums.colors';
import LegalsModalPricesForm from './LegalsModalPricesForm'

const COMPONENT_NAME = 'LegalsModalPrices';

const LegalsModalPrices = ({ data }) => {
  const dispatch = useDispatch();

  const [showLegals, setShowLegals] = useState(false);

  const layout = useSelector((state) => state.UI.layout);
  const clientModules = useSelector((state) => state.client.modulos);
  const modulos = useSelector((state) => state.cart.modulos);

  const componentProduct = getModuleNamesTagginInfo(modulos, layout, clientModules);

  const { subject, legals, provisionalAgreements } = data || {};

  const {
    titleFlyout,
    descriptionFlyout,
  } = legals || {};

  const taggingInfo = {
    componentContent: subject || '',
    componentName: COMPONENT_NAME,
    componentProduct,
    componentVariation: '',
  }

  useEffect(() => {
    sendGaEvent({
      ...taggingInfo,
      eventType: 'print-success',
    })
  }, []);

  const onCloseModal = () => {
     dispatch(
       modalActions.addModal({
        id: '',
        omitAnchorListener: true,
       }),
     );
   };

  return (
    <>
      <div className="LegalsModalPrices">
        <div className="LegalsModalPrices_header">
          
          <CustomLink
            taggingInfo={{ ...taggingInfo, componentContent: 'Cerrar' }}
            onClick={onCloseModal}
          >
            <Glyph
              id={ICON_ID.Cerrar}
              height={18}
              width={18}
              color={TEXT_COLOR.WHITE}
            />
          </CustomLink>
          {titleFlyout && (
            <TextInfo
              kind={TEXT_KIND.PARAGRAPH}
              color={TEXT_COLOR.white}
              size={TEXT_SIZE.T6}
              align="left"
              text={titleFlyout}
            />
          )}
        </div>
        <div className="LegalsModalPrices_provisionalAgreements">
          {descriptionFlyout && (
            <TextInfo
              kind={TEXT_KIND.PARAGRAPH}
              color={TEXT_COLOR.GREY6}
              size={TEXT_SIZE.CAPTION1}
              text={descriptionFlyout}
            />
          )}
        </div>
      </div>
      <style jsx>
{`
  .LegalsModalPrices {
    width: 100%;
    height: 100vh;
    max-width: 900px;
    margin: 0 auto;
    background-color: #fff;
    overflow-y: auto;
    max-height: 100%;
    display: flex;
    flex-direction: column;
  }

  .LegalsModalPrices_header {
    background-color: ${getColor(TEXT_COLOR.MOVISTAR_BLUE)};
    padding: 1.2rem 1.6rem;
    display: flex;
    align-items: center;
    gap: 4rem; /* espacio entre la X y el título */
  }

  .LegalsModalPrices_header :global(p) {
    color: white !important;
    font-size: 1.4rem;
    font-weight: 600;
  }

  /* Bloque Amarillo */
  .LegalsModalPrices_provisionalAgreements {
    margin: 1rem auto;
    width: 90%;
  }


  @media (max-width: 768px) {
    .LegalsModalPrices {
      max-width: 100vw;
      width: 100vw;
      height: 90vh;
      border-radius: 0;
    }
  }
`}
</style>

    </>
  );
};

export default LegalsModalPrices;
